import { ApiService } from "@/api/services/ApiService";
import { IUser } from "@/lib/types";

// ---------------------- Service

export class UserService {
  // --------- Variables

  private static API_URL = import.meta.env.VITE_API_URL;

  // --------- Methods

  static async getUser(upn: string): Promise<IUser> {
    const params = new URLSearchParams({ upn });

    return await ApiService.sendRequest(`${this.API_URL}/api/users?${params}`, {
      method: "GET",
    });
  }
}
